export const MINIMAP_HEIGHT = 120;
export const MINIMAP_SPAN_BAR_HEIGHT = 4;
export const NUM_OF_SPANS_FIT_IN_MINI_MAP = MINIMAP_HEIGHT / MINIMAP_SPAN_BAR_HEIGHT;
export const TIME_AXIS_HEIGHT = 20;
const SECONDARY_HEADER_HEIGHT = 20;
export const PROFILE_MEASUREMENTS_CHART_HEIGHT = 60;
export const MINIMAP_CONTAINER_HEIGHT = MINIMAP_HEIGHT + TIME_AXIS_HEIGHT + SECONDARY_HEADER_HEIGHT + 1;
export const VIEW_HANDLE_HEIGHT = 18;
export const MERGE_LABELS_THRESHOLD_PERCENT = 10;